import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';
import { PARAMETERS } from '../base/service-const';

@Injectable({
  providedIn: 'root'
})
export class ParameterService extends AbstractHttpService<any> {

  constructor(
    protected _httpClient: HttpClient,
    private _toastrService: NbToastrService,
    private appConfigService: AppConfigService
  ) { 
    super(_httpClient, PARAMETERS, appConfigService.apiBaseUrl);
  }

  public getFinalizations() {
    this.customList("finalizations").subscribe((response: any) => {
    }, error => this._toastrService.danger(`Falha ao recuperar os dados de finalizações! Erro: ${error.message}`));
  }
}
